import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CreateNoteModal from './CreateNoteModal';
import { AddButton } from '@rd-web-markets/shared/dist/util/buttons';
const AddNoteButton = _ref => {
  let {
    claimId,
    category,
    userCanEdit = true
  } = _ref;
  const {
    t
  } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  if (!userCanEdit) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AddButton, {
    variant: "link",
    size: "sm",
    onClick: () => setShowModal(true),
    className: "text-decoration-none",
    text: t('add_note'),
    icon: "add"
  }), /*#__PURE__*/React.createElement(CreateNoteModal, {
    show: showModal,
    onHide: () => setShowModal(false),
    claimId: claimId,
    category: category
  }));
};
export default AddNoteButton;